import React, { useEffect } from "react";
import { Row, Alert } from "react-bootstrap";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import "animate.css/animate.min.css";
import "animate.css/animate.compat.css";
import { DEFAULT_BACKGROUND_ALERT_DURATION } from "constants/keys";

interface IBackgroundAlert {
  type: "success" | "danger";
  closeModal: any;
  modalText: string;
  path?: string;
}

const BackgroundAlert: React.FC<IBackgroundAlert> = ({
  type,
  closeModal,
  modalText,
  path,
}) => {
  const { push } = useHistory();

  const testAnim = () => {
    const animationBox = document.getElementById("animationSandbox");

    animationBox?.classList.add("animate__backInRight", "animate__animated");
    animationBox?.addEventListener("animationend", () => {
      animationBox?.classList.remove(
        "animate__backInRight",
        "animate__animated"
      );
    });
  };

  useEffect(() => {
    testAnim();

    const resetTimeout = setTimeout(() => {
      closeModal(false);
      if (path && modalText !== "Token Inválido!") {
        push(path);
      }
    }, DEFAULT_BACKGROUND_ALERT_DURATION);

    return () => {
      clearTimeout(resetTimeout);
    };
  }, [closeModal, path, push, modalText]);

  return (
    <Row className="d-flex justify-content-end mt-1">
      <div className="w-50" id="animationSandbox">
        <Alert
          variant={type}
          onClose={() => {
            closeModal(false);
            if (path && modalText !== "Token Inválido!") {
              push(path);
            }
          }}
          className={classNames("bg-" + type, "border-0", "text-white")}
          dismissible
        >
          <i
            className={`mdi ${
              type === "success" ? "mdi-check-bold" : "close-thick"
            }`}
          />{" "}
          <strong>{type === "success" ? "Sucesso" : "Erro"} - </strong>{" "}
          {modalText}
          {modalText === "Token Inválido!" ? ", você será redirecionado." : ""}
        </Alert>
      </div>
    </Row>
  );
};

export default BackgroundAlert;
